import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit-form"
export default class extends Controller {
  static values = {url: String}

  save(event) {
    const keys = ["authenticity_token", "_method", event.currentTarget.name]

    const formData = new FormData(this.element);

    Array.from(formData.keys()).filter((k)=>!keys.includes(k)).forEach((e)=>formData.delete(e))

    const url = this.hasUrlValue ? this.urlValue : this.element.action;
    return fetch(url, { method: "PUT", body: formData, headers: this.headers })
  }

  get headers() { return { 'X-Requested-With': 'XMLHttpRequest' } }

  getMetaValue(name) {
    const element = this.findElement(document.head, `meta[name="${name}"]`);
    if (element) {
        return element.getAttribute("content");
    }
  }

  findElement(root, selector) {
    if (typeof root == "string") {
        selector = root;
        root = document;
    }
    return root.querySelector(selector);
  }
}
